(function ($) {

    window.resizeColorBox = function () {
        if (window.resizeTimer) clearTimeout(window.resizeTimer);
        window.resizeTimer = setTimeout(function () {
            if (($('#cboxOverlay').is(':visible')) && (ssm.isActive('tablet'))) {
                $.colorbox.resize({ width: '100%', height: '100%' });
            }
        }, 300);
    };

    // Resize Colorbox when resizing window or changing mobile device orientation
    $(window).resize(window.resizeColorBox);
    window.addEventListener("orientationchange", window.resizeColorBox, false);

    $(function () {

        $(document).on('cbox_open', function () {
            $("body").addClass('box-open');
        }).on('cbox_closed', function () {
            $("body").removeClass('box-open');
        });      

        $('a.gallery').colorbox({
            rel: 'gal',
            current: "<i class='fa fa-camera' aria-hidden='true'></i> {current}/{total}",
            maxWidth: '95%',
            maxHeight: '80%',

            scalePhotos: true,
            className: 'listingGallery',
            title: function () {
                return $(this).find("img").attr("title");
            }, 
            alt: function () {
                return $(this).find("img").attr("alt");
            }

        });
    });

    window.showColorbox = function (show) {
        $.colorbox({
            inline: true, href: show, maxWidth: "90%"
        });
    };

    window.hideNotification = function () {
        $("body").addClass('snack-notification-inactive');
        $('.snack-notification').addClass('remove-notification')
            .one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
                $(this).hide().removeClass('remove-notification');
                $("body").removeClass('snack-notification-active').removeClass('snack-notification-inactive');
            });
    };

})(jQuery);